import React from "react";
import "../Css/Python.css";

import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const PyFirstPage = () => {
  const [loading, setLoading] = useState(false);
  let [color] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div className="container-fluid background_py">
              <div className="row">
                <Navbar />

                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/pyLogo.png"}
                      width="60%"
                      alt="pylogo"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <div
              className="container-fluid"
              style={{
                backgroundColor: "black",
                paddingBottom: "65px",
                paddingTop: "60px",
              }}
            >
              <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div className="mt-4">
                    <h1 className="py_h1">Python Tutorial</h1>
                  </div>
                  <div>
                    <p>
                      In this easy python tutorial, you will learn the usage of
                      python, why to learn python language and how to run a
                      python program step by step. Whether you are a beginner in
                      programming or an experienced programmer, you can learn
                      python easily. In This tutorial, all examples are based on
                      the latest version of python 3.
                    </p>
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
              {/* <!-- <hr style="color: white" /> --> */}

              <div className="row">
                <div className="mt-4">
                  <h1 className="py_h1">About Python Language.</h1>
                </div>
                <div>
                  <p>
                    Python is a general-purpose programming language with
                    advanced features. Python was created in the late 1980 and
                    its implementation was started in December 1989. Python 2.0
                    was released on October 16, 2000, and Python 3.0 was
                    released on December 2008, with many major new features.
                    Python is used in many applications, such as Web and
                    internet development, Scientific and Numeric Application,
                    Desktop Application and, in education domain also.
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mt-5">
                  <div>
                    <h1
                      style={{
                        color: "white",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      Why to Learn Python ?
                    </h1>
                    <ul>
                      <li className="text-light">
                        Python language is easy to learn for beginners.
                      </li>
                      <li className="text-light">
                        For AI (Artificial Intelligence) Development.
                      </li>
                      <li className="text-light">
                        Python is for Game Development, Web Development /
                        Desktop Application.
                      </li>
                      <li className="text-light">
                        Machine Learning with Python
                      </li>
                      <li className="text-light">Python is Free.</li>
                      <li className="text-light">
                        You can run python on any Operating System.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-4 mt-5">
                  <div>
                    <h1
                      style={{
                        color: "white",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      Python Application
                    </h1>
                    <ul>
                      <li className="text-light">YouTube</li>
                      <li className="text-light">Google</li>
                      <li className="text-light">Instagram</li>
                      <li className="text-light">Quora</li>
                      <li className="text-light">DropBox.</li>
                      <li className="text-light">Reddit.</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-4 mt-5">
                  <div>
                    <h1
                      style={{
                        color: "white",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      Features Of Python.
                    </h1>
                    <ul>
                      <li className="text-light">It's Very Simple</li>
                      <li className="text-light">It's Easy to Learn</li>
                      <li className="text-light">Free and Open Source</li>
                      <li className="text-light">
                        High-level Language And Object Oriented
                      </li>
                      <li className="text-light">Interpreted</li>
                      <li className="text-light">Portable And Extensible.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <PyFooter />
          </>
        )}
      </div>
    </>
  );
};
